import { PaletteIcon as PhosphorPaletteIcon } from "@phosphor-icons/react/dist/ssr/Palette";

import { createAppIcon } from "@/components/createAppIcon";

export const StyleIcon = /* @__PURE__ */ createAppIcon(PhosphorPaletteIcon);
